export default {
  PLANTIO: 0,
  COLHEITA: 1,
  APLICACAO: 2,
  RECOMENDACAO: 3,
  ALERTA_FITOSSANITARIO: 4,
  MONITORAMENTO: 5,
  REGISTRO_FOTOGRAFICO: 6,
  REGISTRO_CLIMATICO: 7,
  APLICACAO_PRODUTO_PROIBIDO: 8,
  AUDITORIA_PLANTIO: 9,
  SAZONALIDADE: 10
};
